<template>
    <div>
        <Header/>
        <div class="container">
            <div class="row mt-3 mb-3">
                <div class="col-6">
                    <img :src="getImg()" class="img-fluid">
                </div>
                <div class="col-6">
                    <h6 class="text-primary">สร้างบัญชี</h6><hr>
                    <form @submit.prevent="registerCustomers()">
                        <div class="form-group">
                            <label>ชื่อ</label>
                            <input type="text" v-model="form.name" name="name" v-validate="'required|min:4'" class="form-control" :class="{'input': true, 'is-invalid': errors.has('name') }" placeholder="ชื่อ">
                            <i v-show="errors.has('name')" class="fas fa-warning"></i>
                            <span v-show="errors.has('name')" class="text-danger text-10">{{ errors.first('name') }}</span>
                        </div>
                        <div class="form-group">
                            <label>นามสกุล</label>
                            <input type="text" v-model="form.lastname" name="lastname" v-validate="'required|min:4'" class="form-control" :class="{'input': true, 'is-invalid': errors.has('lastname')}" placeholder="นามสกุล">
                            <i v-show="errors.has('lastname')" class="fas fa-warning"></i>
                            <span v-show="errors.has('lastname')" class="text-danger text-10">{{ errors.first('lastname') }}</span>
                        </div>
                        <div class="form-group">
                            <label>เบอร์โทรศัพท์</label>
                            <input type="text" v-model="form.number_phone" name="number_phone" v-validate="'required|numeric|min:6|max:15'" class="form-control" :class="{'input': true, 'is-invalid': errors.has('number_phone')}" placeholder="เบอร์โทรศัพท์">
                            <i v-show="errors.has('number_phone')" class="fas fa-warning"></i>
                            <span v-show="errors.has('number_phone')" class="text-danger text-10">{{errors.first('number_phone')}}</span>
                        </div>
                        <div class="form-group">
                            <label>อีเมล</label>
                            <input type="text" v-model="form.email" name="email" v-validate="'required|email'" class="form-control" :class="{'input': true, 'is-invalid': errors.has('email')}" placeholder="example@mail.com">
                            <i v-show="errors.has('email')" class="fas fa-warning"></i>
                            <span v-show="errors.has('email')" class="text-danger text-10">{{errors.first('email')}}</span>
                        </div>
                        <div class="form-group">
                            <label>รหัสผ่าน</label>
                            <input type="password" v-model="form.password" name="password" v-validate="'required|min:6|max:35'" class="form-control" :class="{'input': true, 'is-invalid': errors.has('password')}" placeholder="รหัสผ่าน">
                            <i v-show="errors.has('password')"></i>
                            <span v-show="errors.has('password')" class="text-danger text-10">{{errors.first('password')}}</span>
                        </div>
                        <div class="form-group">
                            <button type="submit" class="btn btn-block bg-orange text-white">ลงทะเบียน</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <br><br><br><br>
        <Footer/>
    </div>
</template>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
    export default {
        components: {
            Header,Footer,
        },
        data(){
            return {
                form: new Form({
                    name:'',
                    lastname:'',
                    number_phone:'',
                    email:'',
                    password:'',
                })
            }
        },
        methods:{
            registerCustomers(){
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.form.post('http://pgm01.toonjob.com/2019/BannKlong/project/registerCus',)
                        .then((res) => {
                            let data = parseInt(res.data.register)
                            if(data === 1){
                                this.form.reset()
                                toast.fire({
                                    type:res.data.type,
                                    title:res.data.message
                                })
                            }else{
                                toast.fire({
                                    type:res.data.type,
                                    title:res.data.message
                                })
                                return false
                            }
                            console.log(res.data)
                        })
                    }
                })
            },
            getImg(){
                return '../../dist/typeProduct/20190513_1.jpg'
            }
        },
        created(){
            this.$Progress.start()
            
            this.$Progress.finish()
        }
    }
</script>



// WEBPACK FOOTER //
// src/frontEnd/RegisterPage.vue